var _g, _circle, _circle2, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatientArrivalConfirmPickupNonActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_df_3923_84887)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 43,
    fill: "#949292",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 43,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 39,
    fill: "#949292"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.6642 35.8362C64.7465 35.8848 62.9613 34.7978 62.1262 33.0701C61.8522 32.5089 61.2292 32.2128 60.6238 32.3631L53.9648 33.9759L71.5557 51.5667L67.9854 36.848C67.8351 36.2427 67.2872 35.8185 66.6642 35.8362Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7894 56.1583C73.1252 55.6325 73.0545 54.9432 72.6126 54.5013L72.1531 54.0418L52.459 34.3433L51.5046 33.3888C51.2482 33.1326 50.908 33 50.5678 33C50.3203 33 50.0729 33.0707 49.852 33.2121C49.0433 33.7335 48.1198 33.9898 47.1963 33.9898C46.2728 33.9898 45.3449 33.7291 44.5407 33.2121C44.3197 33.0707 44.0723 33 43.8248 33C43.4846 33 43.1443 33.1326 42.8881 33.3888L32.3892 43.8788C31.9474 44.3207 31.8723 45.01 32.2125 45.5314C33.2509 47.1442 33.2509 49.2343 32.2125 50.8471C31.8767 51.3729 31.9474 52.0578 32.3892 52.4997L47.6779 67.7884L53.5017 73.6122C53.758 73.8685 54.0982 74.0011 54.4385 74.0011C54.686 74.0011 54.9334 73.9304 55.1543 73.789C55.9629 73.2676 56.8864 73.0112 57.8099 73.0112C58.7334 73.0112 59.6614 73.2719 60.4656 73.789C60.6866 73.9304 60.934 74.0011 61.1814 74.0011C61.5216 74.0011 61.8619 73.8685 62.1182 73.6122L72.6081 63.1222C73.05 62.6804 73.1207 61.9866 72.7805 61.4608C71.7774 59.8966 71.7509 57.8861 72.6965 56.2998C72.7319 56.2511 72.7628 56.2069 72.7894 56.1583ZM62.3745 50.1003L54.4297 53.6618L56.6346 55.8666H60.5717C60.691 55.8666 60.8014 55.9153 60.8854 55.9948L61.4731 56.5825C61.6941 56.8034 61.6234 57.179 61.3361 57.3027L57.8188 58.8095L56.3032 62.3268C56.1795 62.614 55.8039 62.6848 55.583 62.4638L54.9953 61.8761C54.9113 61.7922 54.8671 61.6817 54.8671 61.5624V57.6253L52.6622 55.4204L49.1008 63.3696C48.9726 63.6524 48.6059 63.7187 48.385 63.5022L47.5189 62.6361C47.4217 62.5389 47.3775 62.4063 47.3908 62.2693L48.6898 51.4524L45.4863 48.2489C45.4509 48.2135 45.42 48.1693 45.3979 48.1207L44.4434 46.0263C44.2755 45.6551 44.6556 45.2707 45.0267 45.443L47.1212 46.3974C47.1698 46.4195 47.214 46.4505 47.2493 46.4858L50.4528 49.6894L61.2698 48.3903C61.4023 48.3726 61.5393 48.4212 61.6365 48.5184L62.5026 49.3845C62.7236 49.601 62.6573 49.9722 62.3745 50.1003Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_df_3923_84887",
    x: 0,
    y: 0,
    width: 106,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3923_84887"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3923_84887"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3923_84887",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect2_foregroundBlur_3923_84887"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientArrivalConfirmPickupNonActive);
export default __webpack_public_path__ + "static/media/PatientArrivalConfirmPickupNonActive.134dea8f41c5021e51de143eec4b984e.svg";
export { ForwardRef as ReactComponent };